import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  addErrorMessage,
  addPositiveMessage,
} from '@greenkub-fronts/domain/snackbar';
import { Address } from '@greenkub-fronts/shared/interface';

export const updateProjectUseCase = createAsyncThunk(
  'updateProjectUseCase',
  async (
    data: {
      displayMsg: boolean;
      comment: string;
      address: Address;
      adjustment: number;
    },
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ): Promise<any> => {
    try {
      const { isSignature, projectId, project } = getState().signature;
      const { user } = getState().auth;

      if (isSignature) return { projectId };

      /**
       * Attribué la bonne sales, celle qui a fait le R1
       */
      let designatedSales = project?.sales;

      /**
       * Si pas encore de Sales, ou que la sales est différente de l'utilisateur courant
       */
      if (!designatedSales || (user && project.sales.id != user.id)) {
        designatedSales = user;
      }

      const result = await dispatch(
        extra.apiSlice.endpoints.patchProject.initiate({
          projectId: project.id,
          project: {
            sales: designatedSales.id,
            address: data.address,
            adjustment: data.adjustment,
            notes: data.comment,
          },
        })
      );

      if (data.displayMsg) {
        if (result.error) {
          dispatch(addErrorMessage(result.error));
        } else {
          dispatch(addPositiveMessage(result.data));
        }
      }
    } catch (e) {
      console.info('e', e);
    }
  }
);

export default updateProjectUseCase;
